import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./components/layout/Navbar.jsx";
import Footer from "./components/layout/Footer.jsx";
import Preloader from "./components/ui/Preloader.jsx";
import styles from "./App.module.css";

export default function App() {
  const { pathname } = useLocation();
  const isFixed = pathname === "/";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Preloader />
      <div className={`theme-studio ${styles.shell} ${isFixed ? styles.fixed : styles.grow}`}>
        <Navbar />
        <div className={styles.view}>
          <Outlet />
        </div>
        {!isFixed && <Footer />}
      </div>
    </>
  );
}
